module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAAXNSR0IB2cksfwAAACFQTFRFAAAA////////////////////////////////////////zyHr+QAAAAt0Uk5TAIjZsA6HNrHMG8vviEqtAAAAU0lEQVR4nGMQUoICEwYGZxhblQHGUlJjYEiCc0aF6SxcBGN1MjDMgLHVGdzSoGACAwMnjJ3CQEuAw0q4A1cyMMyCsZUHUQiOaGF45i5hYHCHsRUBHDSATcNI9oMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--apps-hover@2x.png
// module id = 922
// module chunks = 0